import { Form, Spinner } from "react-bootstrap";
import { useMutation } from "@tanstack/react-query";
import { putRequestByAuth } from "../../../../function/helper";
import { useState } from "react";
import useSharedData from "../../../../hooks/useSharedData";

const StreamingPDFButton = () => {
  const { user, setUserIsStreamingPDF } = useSharedData();
  const [streamPDF, setStreamPDF] = useState(
    user.isStreamingPDF ? true : false
  );

  const { mutate, isPending } = useMutation({
    mutationKey: ["set-streaming-PDF"],
    mutationFn: value =>
      putRequestByAuth("/user/v1/streamingPDF", { isStreamingPDF: value }).then(
        res => {
          if (res && res.status === 200) {
            setStreamPDF(value);
            setUserIsStreamingPDF(value ? 1 : 0);
          }

          return null;
        }
      ),
  });

  return (
    <section className="d-flex flex-wrap align-items-center column-gap-2 mt-4">
      {isPending && (
        <Spinner style={{ width: 20, height: 20, borderWidth: "0.15em" }} />
      )}

      {!isPending && (
        <Form.Check
          id="stream-pdf"
          type="checkbox"
          checked={streamPDF}
          onChange={e => {
            mutate(e.target.checked);
          }}
        />
      )}
      <Form.Label
        htmlFor="stream-pdf"
        className="user-select-none c-pointer m-0"
      >
        <span>دانلود PDF به صورت استریم </span>
        <span>(فایل دانلود نمی‌شود و صرفا در یک صفحه ی جدید باز می‌شود)</span>
      </Form.Label>
    </section>
  );
};

export default StreamingPDFButton;
